import React, { useEffect, useState } from "react";
import Sidebar from "../../comman_page/Sidebar";
import { HeaderDashboard } from "../../comman_page/HeaderDashboard";
import { Container, Row, Col, Spinner } from "react-bootstrap";
import { Footer } from "../../../../../public/containers/footer/Footer";
import {
  book_appointment,
  getserviceClient,
  service_detail_new,
} from "../../../../../Studio-Services/Studio_Services";
import MultiSelect from "../../../../../sharedComponents/MultiSelect";
import moment from "moment";
import { NewDateRange } from "../../../../../sharedComponents/NewDateRange";
import { monthMap } from "../../../../../sharedComponents/MyHelperFunction";
import { returnSummery } from "../../../../../sharedComponents/Helper";

export const ServiceReport = () => {
  const [loder, setLoder] = useState(true);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [allservices, setAllservices] = useState([]);
  const [serviceoption, setServiceoption] = useState([]);
  const [sltSrOption, setSltSrOption] = useState([]);
  const [insoption, setInsoption] = useState([]);
  const [sltinsoption, setSltinsoption] = useState([]);
  const [status, setStatus] = useState([]);
  const [dvalue, setDvalue] = useState();
  const [clientop, setClientop] = useState([]);
  const [selectedClient, setSelectedClient] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [error, setError] = useState({ 'service': '', 'instructor': '', 'status': '', 'client': '', 'daterange': '' });

  const [isSummery, setIsSummery] = useState(true);
  const [totalSumData, setTotalSumData] = useState();
  const [summeryData, setSummeryData] = useState([]);


  const statusop = [
    { value: "Confirm", label: "Mark as Complete" },
    { value: "Completed", label: "Pay Now" },
    { value: "Success", label: "Payment Completed" },
    { value: "Cancel", label: "Cancel" },
  ];

  const getService = async () => {
    const fDate = { pageid: 1, order: 1 };
    const resp = await book_appointment(fDate);
    if (resp) {
      setLoder(false);
      setAllservices(resp.data);
      const ser = [];
      resp.data.map((e) => ser.push({ value: e.id, label: e.service_name }));
      setServiceoption(ser);
    } else {
      setServiceoption([]);
    }
  };

  useEffect(() => {
    if (sltSrOption && sltSrOption.length > 0 && sltSrOption[0].value) {
      const opt = [...insoption];
      const inst = [];
      sltSrOption.forEach(e => {
        const resp = allservices.find((al) => al.id === e.value); // Use `find` instead of `filter`
        if (resp) {
          if (resp.instructor) {
            resp.instructor.forEach((e) => // Use `forEach` instead of `map` since you're not returning a new array
            {
              let preopt = opt.find((pr) => pr.value === e.id);
              let preins = inst.find((pin) => pin.value === e.id);
              if (!preopt && !preins) {
                inst.push({ value: e.id, label: `${e.name}  ${e.lastname}` });
                opt.push({ value: e.id, label: `${e.name}  ${e.lastname}` });
              }
            });
          }
        }
      });
      setInsoption(opt);
    } else setInsoption([]);
  }, [sltSrOption, allservices]);


  const getclients = async (abc) => {
    const fdata = { 'serviceid': abc };
    setLoder(true);
    const resp = await getserviceClient(fdata);
    if (resp) {
      const preData = resp.data;
      setLoder(false);
      const ser = [];
      preData.data.map((e) => ser.push({ value: e.id, label: e.name + ' ' + e.lastname }));
      setClientop(ser);
    } else {
      setClientop([]);
    }
    setLoder(false);
  }


  useEffect(() => {
    const abc = []
    if (sltSrOption && sltSrOption.length > 0) { sltSrOption.forEach((data) => { abc.push(data.value); }) }
    getclients(abc);
  }, [sltSrOption])

  useEffect(() => {
    getService();
  }, []);

  useEffect(() => {
    if (sltSrOption && sltSrOption.length > 0) { setError((pre) => ({ ...pre, 'service': '' })) }
    if (sltinsoption && sltinsoption.length > 0) { setError((pre) => ({ ...pre, 'instructor': '' })) }
    if (status && status.length > 0) { setError((pre) => ({ ...pre, 'status': '' })) }
    if (selectedClient && selectedClient.length > 0) { setError((pre) => ({ ...pre, 'client': '' })) }
    if (startDate) { setError((pre) => ({ ...pre, 'daterange': '' })) }
  }, [sltSrOption, sltinsoption, status, selectedClient, startDate]);

  const handleSubmit = async (e) => {
    setTotalSumData();
    setSummeryData([]);
    let isValid = 1;
    let serviceids = [];
    let instids = [];
    let stids = [];
    let usrids = [];
    if (sltSrOption && sltSrOption.length > 0) { sltSrOption.forEach((data) => { serviceids.push(data.value); }) }
    if (sltinsoption && sltinsoption.length > 0) { sltinsoption.forEach((data) => { instids.push(data.value); }) }
    if (status && status.length > 0) { status.forEach((data) => { stids.push(data.value); }) }
    if (selectedClient && selectedClient.length > 0) { selectedClient.forEach((data) => { usrids.push(data.value); }) }


    if (!serviceids || serviceids.length <= 0) { setError((pre) => ({ ...pre, 'service': '* Required' })); isValid = 2; };
    if (!sltinsoption || sltinsoption.length <= 0) { setError((pre) => ({ ...pre, 'instructor': '* Required' })); isValid = 2; };
    if (!status || status.length <= 0) { setError((pre) => ({ ...pre, 'status': '* Required' })); isValid = 2; };
    if (!selectedClient || selectedClient.length <= 0) { setError((pre) => ({ ...pre, 'client': '* Required' })); isValid = 2; };
    if (!startDate || !endDate) { setError((pre) => ({ ...pre, 'daterange': '* Required' })); isValid = 2; };


    if (isValid !== 1) { return; }

    setLoder(true);

    const payload = {
      'start_date': startDate,
      'end_date': endDate,
      'service': serviceids,
      'instructor': instids,
      'status': stids,
      'clients': usrids
    }

    const resp = await service_detail_new(payload);

    let tableArray = [];
    let totalBaseAmount = 0;
    let totalTax1 = 0;
    let totalTax2 = 0;
    let totalTip = 0;
    let grandTotal = 0;

    if (resp) {
      setLoder(false);
      const pre = resp.data.sort((a, b) => moment(b.service_date) - moment(a.service_date));

      // reportSummeryCalculator();
      pre.forEach(e => {
        let tip = 0.00;
        const parsedTip = parseFloat(e.tip_comment) || 0;
        if (e.tip_comment && !isNaN(parsedTip)) {
          tip = Math.abs(parsedTip);
        }
        let basePrice = parseFloat(e?.finalBaseAmount || 0);
        let discount = parseFloat(e?.finalDiscount || 0);
        let adjPrice = parseFloat(e?.finalAdjustPrice || 0);
        let tax1 = parseFloat(e?.finalTax1 || 0);
        let tax2 = parseFloat(e?.finalTax2 || 0);
        let subTotal = parseFloat(e?.finalAdjustPrice || 0) + tip + parseFloat(e?.finalTax1 || 0) + parseFloat(e?.finalTax2 || 0);
        let finalTip = tip;

        totalBaseAmount += parseFloat(e?.finalBaseAmount || 0);
        totalTax1 += parseFloat(e?.finalTax1 || 0);
        totalTax2 += parseFloat(e?.finalTax2 || 0);
        totalTip += tip;
        grandTotal += parseFloat(e?.finalAdjustPrice || 0) + tip + parseFloat(e?.finalTax1 || 0) + parseFloat(e?.finalTax2 || 0);

        tableArray.push({
          Service: e.service,
          clientName: e.customer,
          Staff: e.staf_name,
          Date: moment(e.service_date).format('DD-MMM-YYYY'),
          Status: e.status == 'Success' ? 'Payment Completed' : e.status == 'Completed' ? 'Pay Now' : e.status == 'Confirm' ? 'Mark as Complete' : 'Cancel Appointment',
          Amount: basePrice,
          Tax_one: tax1,
          Tax_two: tax2,
          tip: finalTip,
          Total: subTotal,
          payment_mode: e.payment_mode,
        })
      });

      tableArray.sort((a, b) => monthMap[a.Date] - monthMap[b.Date]);
      tableArray.push({
        Service: 'Total',
        clientName: '',
        Staff: '',
        Date: '',
        Status: '',
        Amount: parseFloat(totalBaseAmount).toFixed(2),
        Tax_one: parseFloat(totalTax1).toFixed(2),
        Tax_two: parseFloat(totalTax2).toFixed(2),
        tip: parseFloat(totalTip).toFixed(2),
        Total: parseFloat(grandTotal).toFixed(2),
      })
      setTableData(tableArray);


      //  New Code Add //

      let array = [];

      const cash = pre.filter((vi) => vi?.payment_mode?.replace(/\s/g, '').toLowerCase() === 'cash');
      const pos = pre.filter((vi) => vi?.payment_mode?.replace(/\s/g, '').toLowerCase() === 'pos');
      const pass = pre.filter((vi) => vi?.payment_mode?.replace(/\s/g, '').toLowerCase() === 'pass');
      const giftCard = pre.filter((vi) => vi?.payment_mode?.replace(/\s/g, '').toLowerCase() === 'giftcard');
      const check = pre.filter((vi) => vi?.payment_mode?.replace(/\s/g, '').toLowerCase() === 'check');
      const directDebit = pre.filter((vi) => vi?.payment_mode?.replace(/\s/g, '').toLowerCase() === 'directdebit');
      const freePass = pre.filter((vi) => vi?.payment_mode?.replace(/\s/g, '').toLowerCase() === 'freepass');
      const other = pre.filter((vi) => vi?.payment_mode?.replace(/\s/g, '').toLowerCase() === '' || vi?.payment_mode?.replace(/\s/g, '').toLowerCase() === 'visa' || vi?.payment_mode?.replace(/\s/g, '').toLowerCase() === 'mastercard' || vi?.payment_mode?.replace(/\s/g, '').toLowerCase() === 'amex' || vi?.payment_mode?.replace(/\s/g, '').toLowerCase() === 'cron' || vi?.payment_mode?.replace(/\s/g, '').toLowerCase() === 'mc');


      if (cash && cash.length > 0) { const res = returnSummery(cash, 'Cash'); array.push(res); };
      if (pos && pos.length > 0) { const res = returnSummery(pos, 'POS'); array.push(res); };
      if (pass && pass.length > 0) { const res = returnSummery(pass, 'Pass'); array.push(res); };
      if (giftCard && giftCard.length > 0) { const res = returnSummery(giftCard, 'Gift Card'); array.push(res); };
      if (check && check.length > 0) { const res = returnSummery(check, 'Check'); array.push(res); };
      if (directDebit && directDebit.length > 0) { const res = returnSummery(directDebit, 'Direct Debit'); array.push(res); };
      if (other && other.length > 0) { const res = returnSummery(other, 'Credit/Debit'); array.push(res); };
      if (freePass && freePass.length > 0) { const res = returnSummery(freePass, 'Free Pass'); array.push(res); };



      let tr = 0;
      let totBasePrice = 0;
      let totTip = 0;
      let totQuantity = 0;
      let totDiscount = 0;
      let totAdjPrice = 0;
      let totTax1 = 0;
      let totTax2 = 0;
      let totSubTotal = 0;
      if (array && array.length > 0) {
        array.forEach((e) => {
          tr += e.transaction;
          totBasePrice += parseFloat(e.basePrice);
          totQuantity += parseFloat(e.quantity);
          totTip += parseFloat(e.tip);
          totDiscount += parseFloat(e.discount);
          totAdjPrice += parseFloat(e.adjPrice);
          totTax1 += parseFloat(e.tax1);
          totTax2 += parseFloat(e.tax2);
          totSubTotal += parseFloat(e.subTotal);
        })
      }

      const final = {
        transaction: tr,
        totBasePrice: parseFloat(totBasePrice).toFixed(2),
        totQuantity: parseFloat(totQuantity),
        totTip: parseFloat(totTip).toFixed(2),
        totDiscount: parseFloat(totDiscount).toFixed(2),
        totAdjPrice: parseFloat(totAdjPrice).toFixed(2),
        totTax1: parseFloat(totTax1).toFixed(2),
        totTax2: parseFloat(totTax2).toFixed(2),
        totSubTotal: parseFloat(totSubTotal).toFixed(2),
      }
      setTotalSumData(final);
      setSummeryData(array);

    } else setTableData([]);
    setLoder(false);
  };


  const clearHandler = () => {
    setError({ 'service': '', 'instructor': '', 'status': '', 'client': '', 'daterange': '' });
    setSltSrOption([]);
    setSltinsoption([]);
    setStatus([]);
    setSelectedClient([]);
    setDvalue('');
    setTableData([]);
  }

  return (
    <>
      {loder && <div className="MainLoader"> <Spinner animation="border" /> </div>}
      <div className="MainDashboard">
        <div className="MainLayout">
          <Row>
            <Sidebar />
            <Col>
              <div className="RightSide">
                <HeaderDashboard />
                <section className="addClient innerContent">
                  <div className="AddClientContent">
                    <Container>
                      <h4 className='mb-4'>Service Report</h4>
                      <Row className="mt-3">
                        <Col>
                          <MultiSelect options={serviceoption} Label={"Service"} setSelectedOptions={setSltSrOption} selectedOptions={sltSrOption} error={error.service} />
                        </Col>
                        <Col>
                          <MultiSelect Label={"Instructor"} options={insoption} setSelectedOptions={setSltinsoption} selectedOptions={sltinsoption} error={error.instructor} />
                        </Col>
                        <Col>
                          <MultiSelect Label={"Status"} options={statusop} setSelectedOptions={setStatus} selectedOptions={status} error={error.status} />
                        </Col>
                        <Col>
                          <MultiSelect Label={"Client"} options={clientop} setSelectedOptions={setSelectedClient} selectedOptions={selectedClient} error={error.client} />
                        </Col>
                      </Row>
                      <Row className="mt-3">
                        <h5>Date Range</h5>

                        <Col className="d-flex" style={{ justifyContent: 'space-between' }}>
                          <span>
                            <NewDateRange
                              setDvalue={setDvalue}
                              dvalue={dvalue}
                              setStartDate={setStartDate}
                              setEndDate={setEndDate}
                              error={error.daterange}
                            />
                          </span>
                          <span>
                            <button type="button" className="btn btn-success m-1" onClick={handleSubmit}>Run Report</button>
                            <button type="button" className="btn btn-danger m-1" onClick={clearHandler}>Clear Report </button>
                          </span>
                        </Col>
                      </Row>

                      {isSummery ?
                        <>
                          <Row className="mt-3">
                            <Col md={12} className="transactionReport w-100">
                              <table className="table table-striped table-bordered">
                                <thead>
                                  <tr>
                                    <th>Summary</th>
                                    <th>Transaction</th>
                                    <th>Appointment Fee</th>
                                    <th>Discount</th>
                                    <th>Adj Price</th>
                                    <th>Tip</th>
                                    <th>Tax 1</th>
                                    <th>Tax 2</th>
                                    <th>Total</th>
                                  </tr>
                                </thead>
                                <tbody style={{ fontSize: '14px' }}>
                                  {summeryData && summeryData.length > 0 && summeryData.map((row, index) => <tr key={index}>
                                    <td>{row.summary}</td>
                                    <td>{row.transaction}</td>
                                    <td>$ {row.basePrice}</td>
                                    <td>$ {row.discount}</td>
                                    <td>$ {row.adjPrice}</td>
                                    <td>$ {row.tip}</td>
                                    <td>$ {row.tax1}</td>
                                    <td>$ {row.tax2}</td>
                                    <td>$ {row.subTotal}</td>
                                  </tr>)}
                                  {totalSumData &&
                                    <tr className='highlighted highlighted-my'>
                                      <td>Total</td>
                                      <td style={{ width: 'auto', whiteSpace: 'nowrap' }}>{totalSumData?.transaction}</td>
                                      <td style={{ width: 'auto', whiteSpace: 'nowrap' }}>$ {totalSumData?.totBasePrice}</td>
                                      <td style={{ width: 'auto', whiteSpace: 'nowrap' }}>$ {totalSumData?.totDiscount}</td>
                                      <td style={{ width: 'auto', whiteSpace: 'nowrap' }}>$ {totalSumData?.totAdjPrice}</td>
                                      <td style={{ width: 'auto', whiteSpace: 'nowrap' }}>$ {totalSumData?.totTip}</td>
                                      <td style={{ width: 'auto', whiteSpace: 'nowrap' }}>$ {totalSumData?.totTax1}</td>
                                      <td style={{ width: 'auto', whiteSpace: 'nowrap' }}>$ {totalSumData?.totTax2}</td>
                                      <td style={{ width: 'auto', whiteSpace: 'nowrap' }}>$ {totalSumData?.totSubTotal}</td>
                                    </tr>
                                  }
                                </tbody>
                              </table>
                              {summeryData && summeryData.length <= 0 && (<p className="text-center mt-4">No Data Available</p>)}
                            </Col>
                          </Row>
                          {summeryData && summeryData.length > 0 &&
                            <Row>
                              <Col md={12}>
                                <button type="button" className="btn btn-success m-1" onClick={() => { setIsSummery(false) }}>View Details</button>
                              </Col>
                            </Row>
                          }
                        </>
                        :
                        <Row className="mt-3">
                          <Col md={12} style={{ textAlign: "end" }} className="mb-3">
                            <button type="button" className="btn btn-success m-1" onClick={() => { setIsSummery(true) }}>Back</button>
                          </Col>
                          <Col md={12} className="transactionReport w-100" >
                            <table className="table table-striped table-bordered">
                              <thead>
                                <tr>
                                  <th>Service</th>
                                  <th>Client Name</th>
                                  <th>Staff</th>
                                  <th>Date</th>
                                  <th>Status</th>
                                  <th>Payment Method</th>
                                  <th>Total</th>
                                </tr>
                              </thead>
                              <tbody style={{ fontSize: '14px' }}>
                                {tableData && tableData.length > 0 && tableData.map((row, index) =>
                                  <tr key={index} className={index + 1 == tableData.length ? 'highlighted highlighted-my' : ''}>
                                    <td>{row.Service}</td>
                                    <td>{row.clientName}</td>
                                    <td>{row.Staff}</td>
                                    <td >{row.Date}</td>
                                    <td>{row.Status}</td>
                                    <td>{row.payment_mode}</td>
                                    <td style={{ width: 'auto', whiteSpace: 'nowrap' }}>$ {parseFloat(row.Total).toFixed(2)}</td>
                                  </tr>)}
                              </tbody>
                            </table>
                            {tableData && tableData.length <= 0 && (<p className="text-center mt-4">No Data Available</p>)}
                          </Col>
                        </Row>
                      }
                    </Container>
                  </div>
                </section>
                <Footer />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};
